var platformTypes = {
    time_and_attendance: 'TIME_AND_ATTENDANCE',
    payroll: 'PAYROLL',
    tax: 'TAX',
};
var getPlatformTypeName = function (platformType) {
    return platformTypes[platformType || 'payroll'];
};
export default getPlatformTypeName;
